import React from 'react';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';
import { get, map, flow, join, isEmpty } from 'lodash/fp';

const AvailableLocationsCell = ({ dataKey, rowData, ...props }) => (
  <Table.Cell {...props}>
    {!isEmpty(rowData[dataKey])
      ? flow(
          map(get('inventoryLocation.name')),
          join(', ')
        )(rowData[dataKey])
      : 'Not set'}
  </Table.Cell>
);

AvailableLocationsCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

AvailableLocationsCell.defaultProps = {
  rowData: null
};

export default AvailableLocationsCell;
